import { opts } from "../opts.js"
import { voiceSearch } from '../../../../../dist/vendor/instantsearch.js/es/widgets/index.js';

export const widget = voiceSearch;
export const config = {
	...opts.voiceSearch,
};
